import { observable, decorate, action } from 'mobx'

class UiStore {
  constructor () {
    this.state = {
      sidebar: {
        items: [
          {
            name: 'Home',
            path: '/dashboard',
            permission: null
          },
          {
            name: 'Gerar Token',
            path: '/dashboard/gerar-token',
            permission: 'generate_token'
          },
          {
            name: 'Enviar email',
            path: '/dashboard/enviar-email',
            permission: 'send_mail'
          },
          {
            name: 'Arquivos',
            path: '/dashboard/requests',
            permission: 'view_requests'
          }
        ],
        activeItem: null,
        isOpen: false
      }
    }
  }

  setIsOpen(isOpen) {
    this.state.sidebar.isOpen = isOpen
  }

  changeActiveItem (item) {
    this.state.sidebar.activeItem = item
    this.setIsOpen(false)
  }
}

decorate(UiStore, {
  state: observable,
  changeActiveItem: action,
  setIsOpen: action
})

export default UiStore



// WEBPACK FOOTER //
// ./src/stores/uiStore.js